import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { recordHyperDxException } from '../observability/hyperdx';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly sentryHandler = Sentry.createErrorHandler();

  handleError(error: unknown): void {
    const extracted =
      (error as { rejection?: unknown; originalError?: unknown } | null)?.rejection
      ?? (error as { originalError?: unknown } | null)?.originalError
      ?? error;

    if (extracted instanceof Error) {
      recordHyperDxException(extracted);
    } else if (extracted != null) {
      recordHyperDxException(new Error(String(extracted)));
    }

    this.sentryHandler.handleError(error);
  }
}
